import React from 'react';
import styles from '../styles.module.scss';
import { LANDING_PAGE_DATA } from '../config';
import CoverageInfoCard from '../common/CoverageInfoCard';

const Index = () => {
  const { cover_info_section } = LANDING_PAGE_DATA;

  return (
    <section className={styles.coverageInfoSection}>
      <div className={styles.coverageInfoHead}>
        <div className={styles.sectionTitle} style={{ margin: 'unset' }}>
          {cover_info_section.title}
        </div>
        <div className={styles.coverageInfoHighlight}>
          {cover_info_section.colored_text}
        </div>
        <div className={styles.coverageInfoSubtitle}>
          {cover_info_section.subtitle}
        </div>
      </div>
      <div className={styles.coverageInfoCards}>
        {cover_info_section?.cover_list?.map((info) => (
          <CoverageInfoCard key={info.title} carousalItem={info} />
        ))}
      </div>
    </section>
  );
};

export default Index;
